export default __webpack_public_path__ + "static/logo31-c7b972299ecae6845c9d2594d73a76ca.png";